import { render, staticRenderFns } from "./OwnerStepsTabs.vue?vue&type=template&id=66560664"
import script from "./OwnerStepsTabs.vue?vue&type=script&lang=js"
export * from "./OwnerStepsTabs.vue?vue&type=script&lang=js"
import style0 from "./OwnerStepsTabs.vue?vue&type=style&index=0&id=66560664&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports